<template>
  <HeadlessLayout :sections="content" />
</template>

<script>
import SustainabilityFabricsContent from "@/content/SustainabilityFabrics.json";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";

export default {
  name: "Fabrics",
  components: {
    HeadlessLayout,
  },
  data() {
    return {
      content: SustainabilityFabricsContent,
    };
  },
};
</script>
